import React from "react";
import Layout from "../../components/Layout";
import HeroSection from "../../components/HeroSection/HeroSection";
import { useTranslation } from "react-i18next";
import PlayroomDetails from "../../components/playroom/PlayroomDetails/PlayroomDetails";
import { Helmet } from "react-helmet-async";

import heroImage1 from "../../assets/images/playroom/playroom8.jpg";
import heroImage2 from "../../assets/images/playroom/playroom9.jpg";
import heroImage3 from "../../assets/images/playroom/playroom10.jpg";
import heroImage4 from "../../assets/images/playroom/playroom11.jpg";
import heroImage5 from "../../assets/images/playroom/playroom12.jpg";

export default function Playroom() {
  const { t } = useTranslation(["playroom", "links"]);
  return (
    <Layout>
      <Helmet>
        <title>Igraonica</title>
        <meta
          name="description"
          content={
            "Naša igraonica je pažljivo osmišljen prostor gde deca mogu bezbedno da se zabavljaju, učestvuju u kreativnim aktivnostima i steknu nova prijateljstva. Dok vi slavite, mi brinemo da se vaši najmlađi gosti lepo provedu"
          }
        />
        <link rel="canonical" href={"https://vidovdanrestoran.rs/playroom"} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={"Igraonica"} />
        <meta
          property="og:description"
          content={
            "Naša igraonica je pažljivo osmišljen prostor gde deca mogu bezbedno da se zabavljaju, učestvuju u kreativnim aktivnostima i steknu nova prijateljstva. Dok vi slavite, mi brinemo da se vaši najmlađi gosti lepo provedu"
          }
        />
        <meta property="og:image" content={heroImage4} />
        <meta
          property="og:url"
          content={"https://vidovdanrestoran.rs/playroom"}
        />
        <meta property="og:site_name" content="Igraonica" />
        <meta property="og:locale" content="sr_RS" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={"Vidovdan"} />
        <meta
          name="twitter:description"
          content={
            "Naša igraonica je pažljivo osmišljen prostor gde deca mogu bezbedno da se zabavljaju, učestvuju u kreativnim aktivnostima i steknu nova prijateljstva. Dok vi slavite, mi brinemo da se vaši najmlađi gosti lepo provedu"
          }
        />
        <meta name="twitter:image" content={heroImage4} />
      </Helmet>
      <HeroSection
        images={[heroImage1, heroImage2, heroImage3, heroImage4, heroImage5]}
        title={t("playroom_hero_title")}
        subTitle={t("playroom_hero_subtitle")}
        description={t("playroom_hero_description")}
      />
      <PlayroomDetails t={t} />
    </Layout>
  );
}
